/*
 * File: index.tsx
 * Desc: 单选框按钮的形式
 * File Created: 2019-12-06 10:15:48
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React from 'react';
import { Radio } from 'antd';
import classNames from 'classnames';
import { RadioGroupProps } from 'antd/lib/radio';

interface RadioButtonProps extends Omit<RadioGroupProps, 'options'> {
    space?: string | number;
    options: { key?: any; value?: any }[];
}

const RadioButton = (props: RadioButtonProps) => {
    const { space, options, className, ...restProps } = props;
    return (
        <Radio.Group
            {...restProps}
            className={classNames(className, { 'rac-radio-separate': !!space })}
        >
            {options.map(option => (
                <Radio.Button style={{ ...(space && { marginRight: space }) }} value={option.key}>
                    {option.value || option.key}
                </Radio.Button>
            ))}
        </Radio.Group>
    );
};

export default RadioButton;
